import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import {
  Center,
  Card,
  Title,
  Text,
  TextInput,
  PasswordInput,
  Button,
  Stack,
  Anchor,
  Divider,
  Alert,
} from "@mantine/core";
import { IconAlertCircle, IconCheck } from "@tabler/icons-react";
import { useAuth } from "../contexts/AuthContext";

export function SignupPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const { signUp } = useAuth();
  const navigate = useNavigate();

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setLoading(true);

    const { error } = await signUp(email, password, displayName || undefined);
    setLoading(false);

    if (error) {
      setError(error.message);
    } else {
      setSuccess(true);
    }
  }

  if (success) {
    return (
      <Center h="100vh" bg="var(--mantine-color-body)">
        <Card withBorder shadow="sm" padding="xl" radius="md" w={400}>
          <Title order={2} ta="center" mb="xs">
            Check your email
          </Title>
          <Text c="dimmed" size="sm" ta="center" mb="lg">
            We've sent a confirmation link to <strong>{email}</strong>. Click it
            to activate your account.
          </Text>
          <Button fullWidth variant="light" onClick={() => navigate("/login")}>
            Back to sign in
          </Button>
        </Card>
      </Center>
    );
  }

  return (
    <Center h="100vh" bg="var(--mantine-color-body)">
      <Card withBorder shadow="sm" padding="xl" radius="md" w={400}>
        <Title order={2} ta="center" mb="xs">
          Create an account
        </Title>
        <Text c="dimmed" size="sm" ta="center" mb="lg">
          Get started with Showrunner
        </Text>

        <form onSubmit={handleSubmit}>
          <Stack>
            {error && (
              <Alert
                icon={<IconAlertCircle size={16} />}
                color="red"
                variant="light"
              >
                {error}
              </Alert>
            )}
            <TextInput
              label="Display name"
              placeholder="Jane Doe"
              value={displayName}
              onChange={(e) => setDisplayName(e.currentTarget.value)}
            />
            <TextInput
              label="Email"
              placeholder="you@example.com"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.currentTarget.value)}
            />
            <PasswordInput
              label="Password"
              placeholder="Min. 6 characters"
              required
              minLength={6}
              value={password}
              onChange={(e) => setPassword(e.currentTarget.value)}
            />
            <Button fullWidth mt="sm" type="submit" loading={loading}>
              Create account
            </Button>
            <Divider label="or" labelPosition="center" />
            <Text size="sm" ta="center">
              Already have an account?{" "}
              <Anchor component={Link} to="/login" size="sm">
                Sign in
              </Anchor>
            </Text>
          </Stack>
        </form>
      </Card>
    </Center>
  );
}
